import { render, staticRenderFns } from "./ResellerBox.vue?vue&type=template&id=0bd6c0a4"
import script from "./ResellerBox.vue?vue&type=script&lang=js"
export * from "./ResellerBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports